class BPFS {
    constructor() {
        var _this = this;
        window.wlm_bpfs_class_selector = '';
        if (window.wlm_local_data == undefined) {
            window.wlm_local_data = {}
        }

        window.wlm_bpfs_mode = "filter";
        window.wlm_bpfs_plan = 'free'

        if (window.boostPFS) {
            window.wlm_bpfs_plan = "free";
            console.log('free');
            _this.hideShowLoader(true);
            
        } else if (window.bcsffilter) {            
            console.log('paid');
            window.wlm_bpfs_plan = "paid";
            _this.hideShowLoader(true);
        }

        _this.WLMDOMContentLoaded();
        _this.observeHead();
        _this.observeSearch();

    }
    WLMDOMContentLoaded() {
        var _this = this;
        let checkDomStatus = setInterval(() => {
            if (document.readyState === 'complete') {
                clearInterval(checkDomStatus);
                _this.hideShowLoader(false);

                if (window.boostPFS) {
                    console.log('Free');
                    window.wlm_bpfs_plan = "free";
                } else if (window.bcsffilter) {
                    console.log('paid');
                    window.wlm_bpfs_plan = "paid";
                }
            }
        }, 100);
    }

    customFind(arr, callback) {
        for (var i = 0; i < arr.length; i++) {
            var match = callback(arr[i]);
            if (match) {
                return arr[i];
                break;
            }
        }
    }
    saveWLMHideProductLocally(json) {
        if (!window.wlm_local_data.hideProductPayload) {
            window.wlm_local_data.hideProductPayload = json;
        } else if (json.products.length) {
            // need to be create unique array
            window.wlm_local_data.hideProductPayload.products = [].concat(
                window.wlm_local_data.hideProductPayload.products,
                json.products
            );
        }
    }
    hideShowLoader(loader) {
        try {
            if (loader) {
                document.getElementById('wlm-loader-container').style.display = "block";
            } else {
                document.getElementById('wlm-loader-container').style.display = "none";
            }
        } catch (e) {
            console.log(e);
        }

    }

    getProductContainer(wlm_bpfs_mode = "filter") {      
        if (wlm_bpfs_mode === "search") {
            if (window.wlm_bpfs_plan === "free") {
                return document.querySelectorAll(
                    ".boost-pfs-search-suggestion-item-product"
                );
            }
            if ((window.wlm_bpfs_plan === "paid")) {
                return document.querySelectorAll(
                    ".bc-sf-search-suggestion-item-product"
                );
            }
        } else if (wlm_bpfs_mode === "filter") {
            
            if (window.wlm_bpfs_plan === "free" && window.boostPFS !=undefined) {
                try {
                    return window.boostPFS.filter.filterResult.$element[0];
                } catch (e) {

                 }
            }
            if (window.wlm_bpfs_plan === "paid" && window.bcsffilter != undefined) {
                const selector = window.bcsffilter.selector.products;
                return document.querySelector(selector);
            }
        }
    }

    getFilterProductSelector() {
        let selector = ":scope > div";
        return selector;
    }
    getHandleFromProductUrl(url = null) {
        if (url === null) {
            url = currentUrl();
        }

        const tempEl = document.createElement("a");
        tempEl.href = url;
        const matches = tempEl.pathname.match("/products/(.*)");
        return matches && matches.length > 1 && matches[1];
    }
    getProductList() {
        var _this = this;
        const productList = [];

        const productContainer = _this.getProductContainer("filter");

        if (!productContainer) {
            return productList;
        }

        const productSel = _this.getFilterProductSelector();

        const products = productContainer.querySelectorAll(productSel);

        for (let product of products) {
            const productNameAnchorEl = product.querySelector("a");
            if (!productNameAnchorEl) {
                continue;
            }
            const handle = _this.getHandleFromProductUrl(productNameAnchorEl.href);
            productList.push(handle);
        }
        return productList;
    }

    getProductListFromSearch() {
        var _this = this;
        const productList = [];
        const products = _this.getProductContainer("search");

        for (let productNode of products) {
            const productNameAnchorEl = productNode.querySelector("a");
            const handle = _this.getHandleFromProductUrl(productNameAnchorEl.href);
            productList.push(handle);
        }

        return productList;
    }
    getBoostPFSProductsContainer() {
        if (wlm_bpfs_mode === "search") {
            if (window.wlm_bpfs_plan === "free") {
                return document.getElementsByClassName('boost-pfs-search-suggestion-item-product');
            }
            if ((window.wlm_bpfs_plan === "paid")) {
                return document.getElementsByClassName('bc-sf-search-suggestion-item-product');
            }
        } else if (wlm_bpfs_mode === "filter") {
            if (window.wlm_bpfs_plan === "free" && window.boostPFS != undefined ) {
                try {
                    return window.boostPFS.filter.filterResult.$element[0].children;
                } catch (e) {
                    return [];
                }
            }
            if (window.wlm_bpfs_plan === "paid" && window.bcsffilter != undefined ) {
                return document.querySelector(window.bcsffilter.selector.products).children;
            }
        }
    }
    RemoveHideProducts() {
        var _this = this;
        let BoostPFSProductsContainer = _this.getBoostPFSProductsContainer();
        let products = [];
        if (window.wlm_bpfs_mode == "filter") {
            products = _this.getProductList();
        } else {
            products = _this.getProductListFromSearch();
        }
        let wlmRemovedNodes = [];
        products.forEach(function (product) {
            var isHide = _this.customFind(window.wlm_local_data.hideProductPayload.products, function (LocalProduct) {
                return product == LocalProduct.handle;
            });
            if (isHide == undefined) {
                for (var i = 0; i < BoostPFSProductsContainer.length; i++) {
                    let isRemoveContainer = false;
                    let aTagContainers = [];
                    try {
                        aTagContainers = BoostPFSProductsContainer[i].querySelectorAll('a');
                    } catch (e) {
                        aTagContainers = [];
                        console.log(e);
                    }
                    for (var j = 0; j < aTagContainers.length; j++) {
                        let handle = aTagContainers[j].href.split('/');
                        handle = handle[handle.length - 1];
                        handle = handle.split('?');
                        handle = handle[0];
                        if (product == handle) {
                            isRemoveContainer = true;
                        }
                    }
                    if (isRemoveContainer) {
                        BoostPFSProductsContainer[i].remove();
                    }
                }
            }
        });

        _this.hideShowLoader(false);
    }
    checkIsProductHide(handles = []) {
        var _this = this;
        _this.hideShowLoader(true);
        if (!handles || !handles.length) {
            _this.hideShowLoader(false);
            return;
        }
        const filteredHandles = handles.filter((handle) => {
            if (!window.wlm_local_data.hideProductPayload) {
                return true;
            }

            if (!handle) {
                return false;
            }

            let checkHandle = _this.customFind(window.wlm_local_data.hideProductPayload.products, function (product) {
                return product.handle == handle;
            });

            if (checkHandle == undefined) {
                return true;
            } else {
                return false;
            }
        });

        if (filteredHandles.length === 0) {
            _this.RemoveHideProducts();
            return Promise.resolve();
        }
        const maxHandleLimit = 20;
        let from = 0;
        let left = filteredHandles.length;
        let to = maxHandleLimit;

        do {
            let paged = filteredHandles.slice(from, to);
            const url = `/search?view=wlm-api&collectionid=${window.boostPFSAppConfig.general.collection_id}&handle=${paged.join(",")}`;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    var json = JSON.parse(this.responseText);
                    _this.saveWLMHideProductLocally(json);
                }
            }
            xhttp.open("GET", url, false);
            xhttp.send();

            from = to;
            to += maxHandleLimit;
            left -= maxHandleLimit;
        } while (left >= 0);

        _this.RemoveHideProducts();
    }
    isSearchPage(url = null) {
        if (url === null) {
            url = window.location.toString();
        }

        return url.match(/\/search\?/) && url.match(/\/search\?/).length > 0;
    }

    currentUrl() {
        return window.location.toString();
    }

    observeSearch() {
        var _this = this;
        let SerchObserverTimeout = setInterval(function () {
            let SearchContainer = null;
            if (window.wlm_bpfs_plan === "free" && window.boostPFS != undefined && window.boostPFS.search !=undefined) {
                SearchContainer = window.boostPFS.search.children;
            }
            if (window.wlm_bpfs_plan === "paid" && window.bcsffilter != undefined && window.bcsffilter.class !=undefined) {
                SearchContainer = document.querySelector("." + window.bcsffilter.class.searchSuggestionWrapper);
            }

            if (SearchContainer != null) {
                clearInterval(SerchObserverTimeout);
                const observerSearch = new MutationObserver((mutations) => {
                    window.wlm_bpfs_mode = "search";
                    let products = _this.getProductListFromSearch();                    
                    _this.checkIsProductHide(products);
                });

                if (window.wlm_bpfs_plan === "free") {
                    for (var j = 0; j < SearchContainer.length; j++) {
                        observerSearch.observe(SearchContainer[j].$uiMenuElement[0], {
                            subtree: true,
                            childList: true,
                        });
                    }

                }

                if (window.wlm_bpfs_plan === "paid") {
                    observerSearch.observe(SearchContainer, {
                        subtree: true,
                        childList: true,
                    });
                }


            }
        }, 100);

    }
    observeHead() {
        var _this = this;
        const head = document.querySelector("head");
        const observer = new MutationObserver((mutations) => {
            const removedNodes = mutations[0].removedNodes;
            if (!removedNodes.length || !removedNodes[0].src) {
                return;
            }
            const src = removedNodes[0].src;
            const filterRequest = /\/services\.mybcapps\.com\/bc-sf-filter\/filter/;
            const searchRequest = /\/services\.mybcapps\.com\/bc-sf-filter\/search/;

            if (src.match(filterRequest) || _this.isSearchPage()) {
                window.wlm_bpfs_mode = "filter";
                let products = _this.getProductList();                
                _this.checkIsProductHide(products);

            } else if (src.match(searchRequest)) {
                window.wlm_bpfs_mode = "search";
                let products = _this.getProductListFromSearch();              
                _this.checkIsProductHide(products);
            }
        });

        observer.observe(head, {
            subtree: true,
            childList: true,
        });
    }

}
var wlm_BPFSinit = new BPFS();//BFS code with WLM for new version